

































































































































import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import { useUserFeedbackStore } from "@/employee/store/userFeedback";
import { formatMMddyyyyDateString } from "@/shared/dateString";
import { AuthorizedSigner, AuthorizedSignerStatus, UserFeedbackEventAction } from "@/shared/types";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import * as _ from "lodash";
import EditAuthorizedSigner from "@/employee/components/settings/profile/EditAuthorizedSigner.vue";
import { useAuthorizedSignerStore } from "@/employee/store/authorizedSigner";
import { useThemeStore } from "@/shared/store/theme";
import * as Phone from "@/shared/phone";
import * as Ssn from "@/shared/ssn";

const emptyAuthorizedSigner: AuthorizedSigner = {
  id: 0,
  firstName: "",
  middleInitial: "",
  lastName: "",
  dateOfBirth: "",
  ssn: "",
  address1: "",
  address2: "",
  city: "",
  state: "",
  zip: "",
  phone: "",
  status: AuthorizedSignerStatus.Active,
  externalId: "",
  userFamilyMemberExternalId: ""
};

@Component({
  components: { EditAuthorizedSigner }
})
export default class AuthorizedSignerTable extends Vue {
  formatDateString = formatMMddyyyyDateString;
  featureFlagStore = useFeatureFlagStore();
  authorizedSignerStore = useAuthorizedSignerStore();
  themeStore = useThemeStore();
  userFeedbackStore = useUserFeedbackStore();

  editAuthorizedSignerParameters = {
    show: { value: false },
    authorizedSigner: { ...emptyAuthorizedSigner },
    onSave: this.onSaveAuthorizedSigner,
    toggleClose: this.closeEditAuthorizedSignerForm,
    isNew: false
  };
  showDeactivateConfirmationModal = false;
  showActivateConfirmationModal = false;
  isDeactivating = false;
  isActivating = false;

  @Prop ()
  authorizedSigners: AuthorizedSigner[];

  @Prop ({required: false, default: true})
  isActive: boolean;

  get profileAddEditEnabled () {
    return this.featureFlagStore.flags.bend17261EnableProfileAddEdit;
  }

  onSaveAuthorizedSigner () {
    return this.authorizedSignerStore.updateAuthorizedSigner({
      id: this.editAuthorizedSignerParameters.authorizedSigner.id,
      authorizedSigner: this.editAuthorizedSignerParameters.authorizedSigner
    })
    .then(() => {
      this.editAuthorizedSignerParameters.show.value = false;
    })
    .catch(() => {/*noop*/});
  }

  closeEditAuthorizedSignerForm () {
    this.editAuthorizedSignerParameters.show.value = false;
  }

  showEditAuthorizedSignerForm (a: AuthorizedSigner) {
    this.editAuthorizedSignerParameters.authorizedSigner = _.cloneDeep(a);
    this.editAuthorizedSignerParameters.show.value = true;
    this.userFeedbackStore.setUserFeedbackAction(UserFeedbackEventAction.UpdateAuthorizedSigner);
  }

  onDeactivateAuthorizedSigner (authorizedSigner: AuthorizedSigner) {
    this.editAuthorizedSignerParameters.authorizedSigner = _.cloneDeep(authorizedSigner);
    this.showDeactivateConfirmationModal = true;
  }

  closeDeactivateConfirmationModal () {
    this.showDeactivateConfirmationModal = false;
  }

  confirmDeactivate () {
    this.isDeactivating = true;
    this.editAuthorizedSignerParameters.authorizedSigner.status = AuthorizedSignerStatus.Inactive;
    return this.authorizedSignerStore.updateAuthorizedSigner({
      id: this.editAuthorizedSignerParameters.authorizedSigner.id,
      authorizedSigner: this.editAuthorizedSignerParameters.authorizedSigner
    })
    .then(() => {
      this.showDeactivateConfirmationModal = false;
    })
    .catch(() => {/*noop*/})
    .finally(() => {
        this.isDeactivating = false;
      });
  }

  onActivateAuthorizedSigner (authorizedSigner: AuthorizedSigner) {
    this.editAuthorizedSignerParameters.authorizedSigner = _.cloneDeep(authorizedSigner);
    this.showActivateConfirmationModal = true;
  }

  closeActivateConfirmationModal () {
    this.showActivateConfirmationModal = false;
  }

  confirmActivate () {
    this.isActivating = true;
    this.editAuthorizedSignerParameters.authorizedSigner.status = AuthorizedSignerStatus.Active;
    return this.authorizedSignerStore.updateAuthorizedSigner({
      id: this.editAuthorizedSignerParameters.authorizedSigner.id,
      authorizedSigner: this.editAuthorizedSignerParameters.authorizedSigner
    })
    .then(() => {
      this.showActivateConfirmationModal = false;
    })
    .catch(() => {/*noop*/})
    .finally(() => {
        this.isActivating = false;
      });
  }

  collapseId (id: number): string {
    return `collapse-${id}`;
  }

  toggleDetails (collapseId: string) {
    this.$root.$emit("bv::toggle::collapse", collapseId);
    this.toggleCollapsedClass(collapseId);
  }

  toggleCollapsedClass (collapseId: string) {
    const elem = document.getElementById(collapseId);
    if (elem.classList.contains("collapsed")) {
      elem.classList.remove("collapsed");
    } else {
      elem.classList.add("collapsed");
    }
  }

  middleInitial (authorizedSigner: AuthorizedSigner): string {
    if (authorizedSigner.middleInitial) {
      return authorizedSigner.middleInitial;
    }
    return "";
  }

  fullName (authorizedSigner: AuthorizedSigner): string {
    return `${authorizedSigner.firstName} ${this.middleInitial(authorizedSigner)} ${authorizedSigner.lastName}`;
  }

  dateOfBirth (authorizedSigner: AuthorizedSigner): string {
    return this.formatDateString(authorizedSigner.dateOfBirth);
  }

  lastFourSsn (authorizedSigner: AuthorizedSigner): string {
    if (!authorizedSigner || !authorizedSigner.ssn) {
      return "";
    }

    return Ssn.lastFour(authorizedSigner.ssn);
  }

  phoneNumber (authorizedSigner: AuthorizedSigner): string {
    if (!authorizedSigner || !authorizedSigner.phone) {
      return "";
    }

    return Phone.format(authorizedSigner.phone);
  }

  get isEligibleForDebitCard () {
    return this.authorizedSignerStore.isEligibleForDebitCard;
  }
}
